<template>
  <div class="kk_styles">
    <custom-accordion v-for="(style, index) in styles" :key="index" :is-open="style.isOpen">
      <template #titleSlot>
        <style-item :id="index" :name="style.title" @edit-style="editStyle" />
      </template>
      <edit-style />
    </custom-accordion>
  </div>
</template>
<script>
import CustomAccordion from "../../../commons/CustomAccordion.vue";
import StyleItem from "./StyleItem.vue";
import EditStyle from "./EditStyle.vue";
export default {
  components: { StyleItem, CustomAccordion, EditStyle },
  data() {
    return {
      styles: [
        {
          title: "Write",
          isOpen: false,
        },
        {
          title: "Check",
          isOpen: false,
        },
        {
          title: "Test",
          isOpen: false,
        },
      ],
    };
  },
  methods: {
    editStyle(id) {
      this.styles[id].isOpen = !this.styles[id].isOpen;
    },
  },
};
</script>
<style lang="less" scoped>
.kk_styles {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.2rem;
}
</style>
